<template>
  <div class="panel">
    <Title :title="data.themeName" fontColor="brown" />
    <div class="list">
      <template v-for="(item, index) in data.goodsList">
        <Item :data="item" :index="index" :key="item.dataId" v-on="$listeners" />
      </template>
    </div>
  </div>
</template>

<script>
import Title from '@/components/activity/Title'
import Item from './Item'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { Title, Item }
}
</script>

<style lang="less" scoped>
.panel {
  .title {
    padding: 40px 30px;
  }
  .list {
    padding: 0 20px;
    .item + .item {
      margin-top: 24px;
    }
  }
}
</style>